import React from 'react';
import { Wrench, MapPin, Search, Clock, CheckCircle2 } from 'lucide-react';
export function InstallationService() {
  return <section className="py-16 lg:py-24 bg-brand-cream" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4" data-id="element-267">
        <div className="bg-white rounded-2xl shadow-sm border border-brand-border overflow-hidden" data-id="element-268">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-269">
            {/* Image/Visual Side */}
            <div className="bg-brand-green p-8 lg:p-12 flex flex-col items-center justify-center text-white relative overflow-hidden" data-id="element-270">
              <div className="absolute inset-0 opacity-10" style={{
              backgroundImage: 'radial-gradient(#F7F1E6 1px, transparent 1px)',
              backgroundSize: '24px 24px'
            }} data-id="element-271"></div>
              <div className="relative z-10 text-center w-full max-w-sm" data-id="element-272">
                <div className="w-20 h-20 bg-brand-gold/20 text-brand-gold rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-273">
                  <MapPin size={36} data-id="element-274" />
                </div>
                <h3 className="text-2xl font-serif font-bold mb-6" data-id="element-275">
                  Select Service Areas
                </h3>

                <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-276">
                  {['Maryland', 'Virginia', 'Washington DC', 'Pennsylvania', 'West Virginia'].map(state => <span key={state} className="bg-white/10 border border-white/20 px-3 py-1 rounded-full text-sm font-medium" data-id="element-277">
                      {state}
                    </span>)}
                </div>

                <div className="bg-white/5 border border-white/10 rounded-xl p-5 text-left" data-id="element-278">
                  <h4 className="font-bold text-brand-gold mb-3 text-sm uppercase tracking-wider" data-id="element-279">
                    Diagnostic Checklist
                  </h4>
                  <ul className="space-y-2 text-sm text-brand-cream/90" data-id="element-280">
                    <li className="flex items-center gap-2" data-id="element-281">
                      <CheckCircle2 size={16} className="text-brand-gold" data-id="element-282" />{' '}
                      Identify manufacturer
                    </li>
                    <li className="flex items-center gap-2" data-id="element-283">
                      <CheckCircle2 size={16} className="text-brand-gold" data-id="element-284" />{' '}
                      Confirm HOA rules
                    </li>
                    <li className="flex items-center gap-2" data-id="element-285">
                      <CheckCircle2 size={16} className="text-brand-gold" data-id="element-286" />{' '}
                      Check mounting type
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Content Side */}
            <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-287">
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-288">
                Installation and mailbox diagnostics
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-289">
                Need help identifying an existing mailbox, matching an HOA
                requirement, or confirming installation? MidAtlantic offers
                diagnostic and installation support in select areas.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-290">
                <li className="flex items-start gap-3" data-id="element-291">
                  <Search className="text-brand-green shrink-0 mt-1" size={20} data-id="element-292" />
                  <span className="font-medium text-brand-charcoal" data-id="element-293">
                    Free residential diagnostic & estimating service
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-294">
                  <Wrench className="text-brand-green shrink-0 mt-1" size={20} data-id="element-295" />
                  <span className="font-medium text-brand-charcoal" data-id="element-296">
                    Model and manufacturer identification
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-297">
                  <Clock className="text-brand-green shrink-0 mt-1" size={20} data-id="element-298" />
                  <span className="font-medium text-brand-charcoal" data-id="element-299">
                    Replacement options and lead-time guidance
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-300">
                  <CheckCircle2 className="text-brand-green shrink-0 mt-1" size={20} data-id="element-301" />
                  <span className="font-medium text-brand-charcoal" data-id="element-302">
                    HOA matching support & commercial estimating
                  </span>
                </li>
              </ul>

              <a href="/Services.html" className="inline-flex items-center justify-center bg-brand-charcoal hover:bg-brand-green text-white px-8 py-3.5 rounded-md font-semibold transition-colors w-full sm:w-auto" data-id="element-303">
                Ask about installation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}